import { onUnmounted, provide } from 'vue';
import { initScreens, defaultInjectKey } from '../utils/initScreens';
export function useScreens(screens, opts) {
    const s = initScreens(screens);
    provide(opts?.injectKey || defaultInjectKey, s);
    onUnmounted(() => s.cleanup());
    return s;
}
//# sourceMappingURL=screens.js.map